module.exports = __webpack_public_path__ + "static/media/Discover.a21cf19d.svg";